var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { staticClass: "warning", attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("common.warning")))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$ct(
                            "warning-there-are-clients-with-ambigous-vat-number"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-link",
                        {
                          attrs: { disabled: _vm.downloadingTxt },
                          on: {
                            click: function ($event) {
                              return _vm.downloadTxt()
                            },
                          },
                        },
                        [
                          _c("w-fa", { attrs: { icon: "download" } }),
                          _vm._v(" " + _vm._s(_vm.$ct("download-as-txt-file"))),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancelClicked()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel mr",
                  on: {
                    click: function ($event) {
                      return _vm.noClicked()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.no")))]
              ),
              _c(
                "w-button",
                {
                  staticClass: "danger",
                  on: {
                    click: function ($event) {
                      return _vm.yesClicked()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.yes")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }